// =================================================================
// 🚨 CORRECTIF OBLIGATOIRE POUR CHROME 116 (Amplify v6) 🚨
// Sans cela, l'erreur "InvalidApiName" bloquera toujours l'API.
// =================================================================
if (typeof URL.canParse === 'undefined') {
  URL.canParse = function (url: string, base?: string) {
    try {
      new URL(url, base);
      return true;
    } catch (e) {
      return false;
    }
  };
}
import {ResourcesConfig} from 'aws-amplify';

import {
  VITE_API_ENDPOINT,
  VITE_COGNITO_IDENTITY_POOL_ID,
  VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
  VITE_SHORTURL_ENDPOINT,
  VITE_CHATKIT_ENDPOINT,
} from './config';

export const apiName = 'perfect-post-api';
export const restConfig = {
  endpoint: VITE_API_ENDPOINT,
  region: 'eu-west-3',
};

const awsExports: ResourcesConfig = {
  Auth: {
    Cognito: {
      identityPoolId: VITE_COGNITO_IDENTITY_POOL_ID,
      userPoolId: VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
    },
  },
  API: {
    REST: {
      // API Gateway avec signature AWS_IAM automatique (par défaut)
      [apiName]: restConfig,
      ['shorturl']: {
        endpoint: VITE_SHORTURL_ENDPOINT,
        region: 'eu-west-3',
      },
      // ChatKit - utiliser headers per-request (voir exemples dans chatkit-api.ts)
      ['chatkit']: {
        endpoint: VITE_CHATKIT_ENDPOINT,
        region: 'eu-west-3',
      },
    },
  },
};

export {awsExports};
